import { render, staticRenderFns } from "./AutotrsaccHist.vue?vue&type=template&id=35bbb5b1"
import script from "./AutotrsaccHist.vue?vue&type=script&lang=js"
export * from "./AutotrsaccHist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bbb5b1')) {
      api.createRecord('35bbb5b1', component.options)
    } else {
      api.reload('35bbb5b1', component.options)
    }
    module.hot.accept("./AutotrsaccHist.vue?vue&type=template&id=35bbb5b1", function () {
      api.rerender('35bbb5b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/transfer/AutotrsaccHist.vue"
export default component.exports